import { TValidationRules, TCommercialOwnershipVerificationFormViewState } from '../../types';
import {
  ECommercialOwnershipVerificationFormViewFields,
  EIdentificationPersonTypeNone,
  EIdentificationPersonType,
} from '../../enums';

import { CADASTRAL_NUMBER_REG_EX } from '../constants';
import { fieldsByType } from '../maps';

export const validationRules: TValidationRules = {
  [ECommercialOwnershipVerificationFormViewFields.Inn]: (
    value: string,
    state: TCommercialOwnershipVerificationFormViewState,
  ) => {
    const isFieldRequired = getFieldRequired(ECommercialOwnershipVerificationFormViewFields.Inn, state);

    if (isFieldRequired && value?.length === 0) {
      return 'Укажите ИНН';
    }

    const isLegalPersonType =
      state[ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType].value ===
      EIdentificationPersonType.Legal;

    const INNLength = isLegalPersonType ? 10 : 12;
    const cleanedValue = value.replace(/_/g, '');

    if (cleanedValue && cleanedValue.length !== INNLength) {
      return `ИНН должен содержать ${INNLength} цифр`;
    }

    return null;
  },
  [ECommercialOwnershipVerificationFormViewFields.LastName]: (
    value: string,
    state: TCommercialOwnershipVerificationFormViewState,
  ) => {
    const isFieldRequired = getFieldRequired(ECommercialOwnershipVerificationFormViewFields.LastName, state);

    if (isFieldRequired && value.length === 0) {
      return 'Укажите фамилию';
    }

    if (value && value.length > 60) {
      return 'Максимальное количество символов – 60';
    }

    return null;
  },
  [ECommercialOwnershipVerificationFormViewFields.FirstName]: (
    value: string,
    state: TCommercialOwnershipVerificationFormViewState,
  ) => {
    const isFieldRequired = getFieldRequired(ECommercialOwnershipVerificationFormViewFields.FirstName, state);

    if (isFieldRequired && value.length === 0) {
      return 'Укажите имя';
    }

    if (value && value.length > 60) {
      return 'Максимальное количество символов – 60';
    }

    return null;
  },
  [ECommercialOwnershipVerificationFormViewFields.SecondName]: (
    value: string,
    state: TCommercialOwnershipVerificationFormViewState,
  ) => {
    const isFieldRequired = getFieldRequired(ECommercialOwnershipVerificationFormViewFields.SecondName, state);

    if (isFieldRequired && value.length === 0) {
      return 'Укажите отчество';
    }

    if (value && value.length > 60) {
      return 'Максимальное количество символов – 60';
    }

    return null;
  },
  [ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType]: (value: string) => {
    if (!value) {
      return 'Неверное значение';
    }

    return null;
  },
  [ECommercialOwnershipVerificationFormViewFields.CadastralNumber]: (
    value: string,
    state: TCommercialOwnershipVerificationFormViewState,
  ) => {
    const isFieldRequired = getFieldRequired(ECommercialOwnershipVerificationFormViewFields.CadastralNumber, state);

    if (isFieldRequired && value.length === 0) {
      return 'Укажите кадастровый номер';
    }

    if (!CADASTRAL_NUMBER_REG_EX.test(value)) {
      return 'Неверно указан кадастровый номер';
    }

    return null;
  },
  [ECommercialOwnershipVerificationFormViewFields.CompanyName]: () => {
    return null;
  },
};

export const validationRulesEntries = Object.entries(validationRules) as Array<
  [keyof TValidationRules, TValidationRules[keyof TValidationRules]]
>;

export function getFieldRequired(
  fieldName: ECommercialOwnershipVerificationFormViewFields,
  state: TCommercialOwnershipVerificationFormViewState,
): boolean {
  const identificationPersonType = state.identificationPersonType.value || EIdentificationPersonTypeNone.None;

  const fieldsByIdentificationPersonType = fieldsByType[identificationPersonType];

  return fieldsByIdentificationPersonType.require.includes(fieldName);
}
